"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalEvent1ToJSON = exports.HistoricalEvent1FromJSONTyped = exports.HistoricalEvent1FromJSON = exports.instanceOfHistoricalEvent1 = void 0;
var runtime_1 = require("../runtime");
var EventType_1 = require("./EventType");
/**
 * Check if a given object implements the HistoricalEvent1 interface.
 */
function instanceOfHistoricalEvent1(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfHistoricalEvent1 = instanceOfHistoricalEvent1;
function HistoricalEvent1FromJSON(json) {
    return HistoricalEvent1FromJSONTyped(json, false);
}
exports.HistoricalEvent1FromJSON = HistoricalEvent1FromJSON;
function HistoricalEvent1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, EventType_1.EventTypeFromJSON)(json['type']),
        'hourPartition': !(0, runtime_1.exists)(json, 'hour_partition') ? undefined : (new Date(json['hour_partition'])),
        'count': !(0, runtime_1.exists)(json, 'count') ? undefined : json['count'],
    };
}
exports.HistoricalEvent1FromJSONTyped = HistoricalEvent1FromJSONTyped;
function HistoricalEvent1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, EventType_1.EventTypeToJSON)(value.type),
    };
}
exports.HistoricalEvent1ToJSON = HistoricalEvent1ToJSON;
